import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { combineLatest, Observable, throwError, catchError, map, startWith } from 'rxjs';
import { ModalService } from '../../../core/modal/modal.service';
import { showErrorAlert } from '../../../shared/components/alerts/alert.decorator';
import { ModalModule } from '../../../core/modal/modal.module';
import { SharedModule } from '../../../shared/shared.module';
import { CtoApiService } from '../../../core/modules/cto/cto-api.service';
import { KkmsApiService } from '../../../core/modules/kkms/kkms-api.service';
import { ICto } from '../../../core/modules/cto/cto.types';

@Component({
  selector: 'tax-cto-modal',
  templateUrl: './cto-modal.component.html',
  styleUrls: ['./cto-modal.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ModalModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    NgIf,
    NgFor,
  ],
})
export class CtoModalComponent implements OnInit {
  // @ts-ignore
  @Input() initialState;

  defaultSelectedCto: string = '';
  selectedCto: string = '';

  // @ts-ignore
  filter: UntypedFormControl;
  // @ts-ignore
  ctos$: Observable<Array<ICto>>;
  // @ts-ignore
  filter$: Observable<string>;
  // @ts-ignore
  filteredList$: Observable<Array<ICto>>;
  readonly kkmInisModels$ = this.getKkmInisModels();

  constructor(
    private kkmsApiService: KkmsApiService,
    private ctoApiService: CtoApiService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.ctos$ = this.ctoApiService.fetchCtoList();
    this.filter = new UntypedFormControl('');
    this.filter$ = this.filter.valueChanges.pipe(startWith(''));
    this.filteredList$ = this.filterList(this.filter$, this.ctos$).pipe(catchError(
      (err: unknown) => {
        this.closeModal();
        return throwError(err);
      },
    ));
    this.defaultSelectedCto = this.initialState.cto ? this.initialState.cto.iinOrBin : '';
  }

  @showErrorAlert()
  private filterList(filter$: Observable<string>, ctoList$: Observable<ICto[]>): Observable<Array<ICto>> {
    return combineLatest(ctoList$, filter$).pipe(
      map(
        ([list, filterString]) => list.filter(
          (item: ICto) => item.name.toLocaleLowerCase().includes(filterString.toLocaleLowerCase())
            || item.address.split(',')[0].toLocaleLowerCase().includes(filterString.toLocaleLowerCase()),
        ),
      ),
    );
  }

  closeModal() {
    this.modalService.close();
  }

  // @ts-ignore
  onRadioButtonChange(cto): void {
    this.selectedCto = cto;
  }

  // @ts-ignore
  getServicedModels(servicedModelsObject): Array<string> {
    return Object.values(servicedModelsObject);
  }

  // @ts-ignore
  selectModel({ title, index }): void {
    this.ctos$ = index === 0 ? this.ctoApiService.fetchCtoList() : this.ctoApiService.fetchCtoList(title);
    this.filteredList$ = this.filterList(this.filter$, this.ctos$);
  }

  saveSelectedCto(): void {
    this.modalService.close(this.selectedCto);
  }

  private getKkmInisModels(): Observable<{ title: string; index: number }[]> {
    return this.kkmsApiService.fetchKkmInisModels().pipe(
      map((models) => {
        models.unshift('cto.add.models.all');
        return models.map((title, index) => ({
          title, index,
        }));
      }),
    );
  }
}
